import { useMemo } from 'react';
import { apiKeyManager } from '@empiriecom/mybuy-session/ApiKey';
import { CustomerApi as GeneratedCustomerApi } from '@empiriecom/mybuy-frontend-api/backend-mybuy-customer/v1/apis/CustomerApi';
import { Configuration } from '@empiriecom/mybuy-frontend-api/backend-mybuy-customer/v1/runtime';
import FixFeatureUrlMiddleware from '@empiriecom/mybuy-session/fixFeatureUrlMiddleware/index';
import { useSession } from '../SessionProvider';
import { useConfig } from '../../hooks';

const isClient = typeof window !== 'undefined';

/*
 * This is a temporary implementation until it is decided how the mybuy packages should be migrated to the nextjs Stack
 * TODO: when above is done, remove this and use the new fully migrated APIs
 */
export const useCustomerApi = () => {
  const { jwtToken, loading } = useSession();
  const config = useConfig();

  return useMemo<GeneratedCustomerApi | null>(() => {
    if (isClient && !loading && jwtToken) {
      return new GeneratedCustomerApi(
        new Configuration({
          fetchApi: (input, init) => fetch(input, init),
          headers: { accept: 'application/json' },
          apiKey: jwtToken,
          middleware: [
            apiKeyManager.sessionInvalidationMiddleware,
            new FixFeatureUrlMiddleware('feature-backend-customer'),
          ],
          basePath: config.apiEndpoints.customer,
        }),
      );
    }
    return null;
  }, [config, jwtToken, loading]);
};
